import operationsHistoricalRoute from './operations-historical-route'
import operationsUploadRoute from './operations-upload-route'
import { Roles } from '../../../../shared/constants'

export default () => ({
  path: '/operations',
  name: 'operations',
  component: () => import(/* webpackChunkName: "operations-root" */ '../../../views/Operations/OperationsRoot.vue'),
  meta: {
    main: true,
    title: 'Operations',
    allowedUserRoles: [
      Roles.RADAR_ADMIN,
      Roles.RADAR_OPS,
      Roles.RADAR_OPS_LEGACY,
      Roles.RADAR_TEST,
      Roles.RADAR_VIEW,
    ],
  },
  redirect: { name: 'operations-upload' },
  children: [
    operationsUploadRoute(),
    operationsHistoricalRoute(),
  ],
})
